import React from 'react';
import { Trans } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import Button from 'src/components/Button';
import Meta from 'src/components/Meta';
import s from './AccessDeniedCustomPage.styles';

const AccessDeniedCustomPage = ({requestingUrl}) => (
  <s.Container>
    <s.GreyBox>
      <Meta title="Access Denied" />
      <s.ContentContainer>
        <s.Icon name="information-circle" />
        <s.AccessDeniedTextArea>
          <div><Trans>ACCESS_DENIED_PAGE_NOT_AVAILABLE</Trans></div>
          <div><Trans>ACCESS_DENIED_JOB_NOT_ACCESSIBLE</Trans></div>
          <div><Trans>ACCESS_DENIED_TRY_AGAIN_LATER</Trans></div>
        </s.AccessDeniedTextArea>
        <s.ButtonContainer>
          <a href={requestingUrl}>
            <Button orange md solid>
              <Trans>ACCESS_DENIED_PREVIOUS_PAGE</Trans>
            </Button>
          </a>
        </s.ButtonContainer>
      </s.ContentContainer>
    </s.GreyBox>
  </s.Container>
);

export default React.memo(withRouter(AccessDeniedCustomPage));
